/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { environmentsList } from "../funcs/environmentsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListEnvironmentsResult } from "../models/components/listenvironmentsresult.js";
import {
  ListEnvironmentsRequest,
  ListEnvironmentsSecurity,
} from "../models/operations/listenvironments.js";
import { unwrapAsync } from "../types/fp.js";
export type ListEnvironmentsQueryData = ListEnvironmentsResult;

export function prefetchListEnvironments(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListEnvironmentsRequest | undefined,
  security?: ListEnvironmentsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListEnvironmentsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListEnvironmentsQuery(
  client$: GramCore,
  request?: ListEnvironmentsRequest | undefined,
  security?: ListEnvironmentsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListEnvironmentsQueryData>;
} {
  return {
    queryKey: queryKeyListEnvironments({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listEnvironmentsQueryFn(
      ctx,
    ): Promise<ListEnvironmentsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(environmentsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListEnvironments(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "environments", "list", parameters];
}
